import './style.css';

import createReactClass from 'create-react-class';
import React from 'react';
import InputMixin from '../../../mixins/input-mixin';
import PublishMixin from '../../../mixins/publish-mixin';
import Edit from './components/edit';
import type { IProps as IReadonlyProps } from './components/readonly';
import ReadOnly from './components/readonly';

export interface IProps extends IReadonlyProps {
  readOnly?: boolean;
  errorText?: boolean;
}

const Text = createReactClass<IProps>({
  displayName: 'Text',
  mixins: [PublishMixin, InputMixin('input')],

  getInitialState() {
    this.input = React.createRef();
  },

  focus(options?: FocusOptions) {
    if (!this.focus) {
      return;
    }

    this.input.current?.focus(options);
  },

  shouldComponentUpdate(props: IProps) {
    if (this.props.errored || this.props.warning) return true;
    if (this.props.value !== props.value) return true;
    if (this.props.readOnly !== props.readOnly) return true;
    if (this.props.errorText !== props.errorText) return true;
    if (this.props.src !== props.src) return true;

    return false;
  },

  render() {
    if (this.props.readOnly) {
      return <ReadOnly {...this.props} />;
    }

    return <Edit ref={this.input} {...this.props} />;
  }
});

export default Text;
